import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { EngageComponent } from '../engage/engage.component';
import { ErrorOverlayService } from '../error-overlay/error-overlay.service';

export const noError: CanDeactivateFn<EngageComponent> = (component: EngageComponent): boolean => {
  const overlay = inject(ErrorOverlayService);
  return !overlay.isShown;
}
